import type { FC } from "react";

import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

const PDFButtonContainer = styled.div`
    @media print {
        display: none;
    }
`;

interface IPDFButtonProps {
    onClick: () => Promise<void>;
    isLocked: boolean;
    isDisabled?: boolean;
    isLoading?: boolean;
}

export const PDFButton: FC<IPDFButtonProps> = ({ onClick, isLocked, isDisabled, isLoading = false }) => {
    return (
        <PDFButtonContainer>
            <IconButton
                isDisabled={isDisabled}
                isLoading={isLoading}
                onClick={onClick}
                iconName={isLocked ? "locked" : "download"}
                type="flat"
            >
                {translate("btn.download.pdf")}
            </IconButton>
        </PDFButtonContainer>
    );
};
